'use strict';

import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

export default class InviewSensor extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    active: PropTypes.bool,
    partialVisibility: PropTypes.bool,
    delay: PropTypes.number,
    delayedCall: PropTypes.bool,
    children: PropTypes.element,
    minTopValue: PropTypes.number
  }

  static contextTypes = {
    infiniteScrollComponent: PropTypes.object,
  }

  static defaultProps = {
    active: true,
    partialVisibility: false,
    minTopValue: false,
    children: React.createElement('span')
  }

  constructor(props) {
    super(props)
    this.state = {
      isVisible: null,
    };
    this.check = _.throttle(this.check.bind(this), 100);
  }

  componentDidMount() {
    if (this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
      this.eventAdded = true;
      if (this.context.infiniteScrollComponent.scrollComponent.scrollHeight <= this.context.infiniteScrollComponent.scrollWindow.clientHeight) {
        this.setState({ isVisible: true })
        this.props.onChange(true);
      } else
        this.context.infiniteScrollComponent.scrollWindow.addEventListener('scroll', this.check);
    }
  }

  componentWillUnmount() {
    if (this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
      this.context.infiniteScrollComponent.scrollWindow.removeEventListener('scroll', this.check);
      this.check = undefined
    }
  }

  UNSAFE_componentWillUpdate(nextProps, nextState, nextContext) {
    if (!this.eventAdded && this.context.infiniteScrollComponent && this.context.infiniteScrollComponent.scrollWindow) {
      this.context.infiniteScrollComponent.scrollWindow.addEventListener('scroll', this.check);
      this.eventAdded = true;
    }
  }

  check(forced = false) {
    if (!forced && !document.hasFocus() || !this.check)
      return;

    const el = ReactDOM.findDOMNode(this);
    if (!el || !this.context.infiniteScrollComponent || !this.context.infiniteScrollComponent.scrollWindow)
      return;

    const rect = el.getBoundingClientRect();
    const containmentRect = this.context.infiniteScrollComponent.scrollWindow.getBoundingClientRect();
    const isVisible = rect.top >= containmentRect.top && rect.bottom <= containmentRect.bottom

    // notify the parent when the value changes
    if (this.state.isVisible !== isVisible) {
      this.setState({ isVisible });
      if (isVisible)
        this.context.infiniteScrollComponent.scrollWindow.removeEventListener('scroll', this.check);
      this.props.onChange(isVisible);
    }

    return this.state;
  }

  render() {
    return React.Children.only(this.props.children);
  }
}



// WEBPACK FOOTER //
// ./src/web/components/infinite-scroller/InviewSensor.js